module.exports = __webpack_public_path__ + "static/media/nozomi-arimura-win.afe426e3.jpg";